
import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../dashboard.service';

interface TherapeuticArea {
  id: string;
  name: string;
  icon: string;
}

@Component({
  selector: 'app-therapeutic-selection',
  templateUrl: './therapeutic-selection.component.html',
  styleUrls: ['./therapeutic-selection.component.scss']
})
export class TherapeuticSelectionComponent implements OnInit {
  selectedAreas: string[] = [];
  therapeuticAreas: string[] = [];

  constructor(private dashboardService: DashboardService) {}

  ngOnInit() {
    this.dashboardService.pdufaInformation$.subscribe((res) => {
      this.therapeuticAreas = res?.therapeutic_categories || [];
      console.log('Available therapeutic areas:', this.therapeuticAreas);
    });
    this.dashboardService.filters$.subscribe(filters => {
      console.log('Filters received in therapeutic selection:', filters);
      const incomingAreas = Array.isArray(filters?.therapeuticAreas) ? filters.therapeuticAreas : [];
      const allowedAreas = new Set(this.therapeuticAreas);
      // Keep only areas that exist in available therapeuticAreas
      this.selectedAreas = incomingAreas.filter(area => allowedAreas.has(area));
      // Remove duplicates from selectedAreas array
      this.selectedAreas = [...new Set(this.selectedAreas)];
      console.log('Updated selectedAreas (after deduplication):', this.selectedAreas);
     
    });
  }

  toggleAreaSelection(area: string) {
    console.log('Toggling therapeutic area selection for:', area);
    console.log('Current selectedAreas before toggle:', this.selectedAreas);
    
    const index = this.selectedAreas.indexOf(area);
    if (index > -1) {
      this.selectedAreas.splice(index, 1);
      console.log('Removed area, new array:', this.selectedAreas);
    } else {
      this.selectedAreas.push(area);
      console.log('Added area, new array:', this.selectedAreas);
    }
    
    // Remove duplicates to prevent issues
    this.selectedAreas = [...new Set(this.selectedAreas)];
    
    console.log('Final selectedAreas length:', this.selectedAreas.length);
    this.dashboardService.updateFilters({ therapeuticAreas: this.selectedAreas });
  }

  proceedWithSelection() {
    if (this.selectedAreas.length > 0) {
      this.dashboardService.selectTherapeuticArea(this.selectedAreas.join(','));
    }
  }

  // Getter to check if area is selected
  isAreaSelected(area: string): boolean {
    const isSelected = this.selectedAreas.includes(area);
    console.log(`Checking if ${area} is selected:`, isSelected, 'selectedAreas:', this.selectedAreas);
    return isSelected;
  }

  // Getter to check if can proceed
  get canProceed(): boolean {
    return this.selectedAreas.length > 0;
  }
}
